'use strict';

/**
 * Unique object identifier.
 *
 * @export
 */
export type RemoteObjectId = string;
